<p-toast></p-toast>
<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<!-- OVERLAY SCREEN-->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{lbl_loading}}</span>
</div>



<p-toolbar styleClass="p-mb-4">
    <ng-template pTemplate="left">
        <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
            (click)="goBack()"></button>
    </ng-template>
</p-toolbar>
<p-fieldset>


    <ng-template pTemplate="header">{{lbl_following_up}} {{lbl_school_prep_guides}}
        {{lbl_future_guide}}</ng-template>


    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <div class="card">
                <div class="p-fluid">
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">

                        <label for="opt">{{lbl_zone}}</label>
                        <div class="p-col-12 p-md-10">
                            <p-dropdown [options]="listZones" [(ngModel)]="selectedZone" optionLabel="descri"
                                [showClear]="true" placeholder="{{lbl_select}} {{lbl_zone}}"
                                (onChange)="loadNatios($event)"></p-dropdown>
                        </div>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <label for="opt">{{lbl_natio}}</label>
                        <div class="p-col-12 p-md-10">
                            <p-dropdown [options]="listNatio" [(ngModel)]="selectedNatio" optionLabel="descri"
                                [showClear]="true" placeholder="{{lbl_select}} {{lbl_natio}}"
                                (onChange)="loadLocals($event)"></p-dropdown>
                        </div>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <label for="opt">{{lbl_local}}</label>
                        <div class="p-col-12 p-md-10">
                            <p-dropdown [virtualScroll]="true" [options]="listLocal" [(ngModel)]="selectedLocal"
                                itemSize="30" optionLabel="descri" [showClear]="true" (onChange)="searchLocal($event)"
                                placeholder="{{lbl_select}} {{lbl_local}}"></p-dropdown>
                        </div>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <label for="opt">{{lbl_status}}</label>
                        <div class="p-col-12 p-md-10">
                            <p-dropdown [virtualScroll]="true" [options]="listFGStatus" [(ngModel)]="selectedFGStatus"
                                itemSize="30" optionLabel="value" [showClear]="true"
                                (onChange)="searchLocal($event)"></p-dropdown>
                        </div>
                    </div>

                </div>
                <div class="p-field">
                    <button pButton pRipple label="{{lbl_search}}" icon="pi pi-search" class="p-button-info p-mr-2"
                        (click)="search()" pTooltip="{{lbl_search}}"></button>
                </div>
            </div>
        </div>
    </div>


    <p-table #dt [value]="listRecords" [rows]="50" [paginator]="true"
        [globalFilterFields]="['guideName','schoolName','localName','natioName']" [rowHover]="true" dataKey="guideId"
        styleClass="p-datatable-customers"
        currentPageReportTemplate="{{lbl_showing}} {first} {{lbl_of}} {last} {{lbl_records}}"
        [showCurrentPageReport]="true">
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between">
                <h5 class="p-m-0">{{lbl_participants}} </h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{lbl_search}}..." />
                </span>
            </div>

            <span class="p-input-icon-left">


                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
            </span>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>

                <th pSortableColumn="name">{{lbl_id}}<p-sortIcon field="name"></p-sortIcon></th>
                <th pSortableColumn="lastName">{{lbl_name}}<p-sortIcon field="lastName"></p-sortIcon></th>
                <th pSortableColumn="lastName">{{lbl_school}}<p-sortIcon field="lastName"></p-sortIcon></th>
                <th pSortableColumn="stage">{{lbl_stage}}<p-sortIcon field="stage"></p-sortIcon></th>
                <th pSortableColumn="strDate">{{lbl_starting_date}}<p-sortIcon field="strDate"></p-sortIcon></th>
                <th pSortableColumn="wrksName">{{lbl_workshop}} {{lbl_supervised}}<p-sortIcon
                        field="wrksName"></p-sortIcon></th>
                <th pSortableColumn="wrksStrDate">{{lbl_starting_date}}<p-sortIcon field="wrksStrDate"></p-sortIcon>
                </th>
                <th pSortableColumn="wrksStrDate" *ngIf="selectedFGStatus && selectedFGStatus.valueId=='B'">
                    {{lbl_comments}}<p-sortIcon field="wrksStrDate"></p-sortIcon></th>
                <th pSortableColumn="localName">{{lbl_local}}<p-sortIcon field="localName"></p-sortIcon></th>
                <th pSortableColumn="natioName">{{lbl_natio}}<p-sortIcon field="natioName"></p-sortIcon></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-gui>
            <tr>
                <td>{{gui.guideId}}</td>
                <td>{{gui.guideName}}</td>
                <td>{{gui.schoolName}}</td>
                <td>{{gui.stageNum }}</td>
                <td>{{formatDate(gui.stageStrDate)}}</td>
                <td>{{gui.superServ}}</td>
                <td>{{formatDate(gui.supSerStrDate)}}</td>
                <td *ngIf="selectedFGStatus.valueId=='B'">{{gui.lastComment}}</td>
                <td>{{gui.localName}}</td>
                <td>{{gui.natioName}}</td>
            </tr>
        </ng-template>

        <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between">
                {{lbl_total}} {{listFutureGuides2 ? listFutureGuides2.length : 0 }} {{lbl_records}}.
            </div>
        </ng-template>
    </p-table>



</p-fieldset>